import type { SolanaWithdrawalStatus, SolanaWithdrawalView } from "@priceon/shared";

const activeWithdrawalStatuses = new Set<SolanaWithdrawalStatus>([
  "pending",
  "processing",
  "submitted",
  "confirmed",
]);

export function isWithdrawalActive(status: SolanaWithdrawalStatus): boolean {
  return activeWithdrawalStatuses.has(status);
}

export function hasActiveWithdrawals(
  withdrawals: readonly SolanaWithdrawalView[] | undefined,
): boolean {
  return withdrawals?.some((withdrawal) => isWithdrawalActive(withdrawal.status)) ?? false;
}

export function hasTerminalWithdrawalTransition(
  previous: readonly SolanaWithdrawalView[] | undefined,
  next: readonly SolanaWithdrawalView[],
): boolean {
  if (!previous?.length) return false;
  const previousStatuses = new Map(previous.map((withdrawal) => [withdrawal.id, withdrawal.status]));
  return next.some((withdrawal) => {
    const previousStatus = previousStatuses.get(withdrawal.id);
    return previousStatus !== undefined
      && isWithdrawalActive(previousStatus)
      && !isWithdrawalActive(withdrawal.status);
  });
}
